import companiesUpdateComponent from './companies-update.component';

const companiesUpdateModule = angular
  .module('companiesUpdate', [])
  .component('companiesUpdate', companiesUpdateComponent);

export default companiesUpdateModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-update/companies-update.js
 **/